import Cookies from 'universal-cookie';

const cookies = new Cookies();

export const ACCESS_TOKEN_COOKIE = 'ap-at';
export const REFRESH_TOKEN_COOKIE = 'ap-rt';

/**
 * Options shared by set and remove. A cookie is only deleted when it is removed
 * with the same domain and path it was set with.
 */
export const getTokenCookieOptions = () => {
    const isProd = process.env.NODE_ENV === 'production';
    return {
        domain: isProd ? window.location.hostname : 'localhost',
        secure: isProd ? true : undefined,
        sameSite: isProd ? ('lax' as const) : undefined,
        path: '/'
    };
}

export const setTokenCookie = (key: string, value: string) => {
    cookies.set(key, value,
        {
            ...getTokenCookieOptions(),
            maxAge: key === ACCESS_TOKEN_COOKIE ? 86400 : 604800, //refresh token keep for a week
        });
}

export const removeTokenCookies = () => {
    const options = getTokenCookieOptions();
    cookies.remove(ACCESS_TOKEN_COOKIE, options);
    cookies.remove(REFRESH_TOKEN_COOKIE, options);
}
